import { render } from "./FormTrainingHeadRegionAnchor.vue?vue&type=template&id=0bfe546f&scoped=true&ts=true"
import script from "./FormTrainingHeadRegionAnchor.vue?vue&type=script&lang=ts"
export * from "./FormTrainingHeadRegionAnchor.vue?vue&type=script&lang=ts"

import "./FormTrainingHeadRegionAnchor.vue?vue&type=style&index=0&id=0bfe546f&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfe546f"]])

export default __exports__